import angular from 'angular';

/* @ngInject */
class PageHeader {
	constructor($rootScope) {
		this.$rootScope = $rootScope;

		this.title         = null;
		this.subtitle      = null;
		this.description   = null;
		this.breadcrumbs   = null;
		this.actionButtons = [];
		this.listeners     = {
			onUpdated: [],
			onClicked: [],
		};
	}

	setTitle(title) {
		this.title = title;

		this.fireUpdatedEvent();

		return this;
	};

	setSubtitle(subtitle) {
		this.subtitle = subtitle;

		this.fireUpdatedEvent();

		return this;
	};

	setDescription(description) {
		this.description = description;

		this.fireUpdatedEvent();

		return this;
	};

	setBreadcrumbs(breadcrumbs) {
		this.breadcrumbs = breadcrumbs;

		this.fireUpdatedEvent();

		return this;
	};

	setActionButton(actionButton) {
		const length = this.actionButtons.push(actionButton);

		this.fireUpdatedEvent();

		return length - 1;
	};

	getTitle() {
		return this.title;
	};

	getSubtitle() {
		return this.subtitle;
	};

	getDescription() {
		return this.description;
	};

	getBreadcrumbs() {
		return this.breadcrumbs;
	};

	getActionButtons() {
		return this.actionButtons;
	};

	fireUpdatedEvent() {
		this.$rootScope.$broadcast('pageHeaderService.updated');
	};

	fireClickedEvent(index) {
		this.$rootScope.$broadcast('pageHeaderService.clicked.' + index);
	};

	onUpdated(callback) {
		this.listeners.onUpdated.push(this.$rootScope.$on('pageHeaderService.updated', callback));
	};

	onClicked(index, callback) {
		if (typeof callback === 'undefined') {
			callback = index;
			index    = 0;
		}

		this.listeners.onClicked.push(this.$rootScope.$on('pageHeaderService.clicked.' + index, callback));
	};

	reset() {
		this.title         = null;
		this.subtitle      = null;
		this.description   = null;
		this.breadcrumbs   = null;
		this.actionButtons = [];

		angular.forEach(this.listeners.onUpdated, (listener) => {
			listener();
		});

		angular.forEach(this.listeners.onClicked, (listener) => {
			listener();
		});

		this.fireUpdatedEvent();
	};
}

export default PageHeader;


// WEBPACK FOOTER //
// ./src/js/services/pageHeader/index.js